<smrts-page primaryTitle="Realizar Vistoria">

  <div header class="header-container">
    <button mat-icon-button matTooltip="Voltar" class="accent-color btn-voltar" (click)="voltar()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <mat-divider [vertical]="true" class="divisor-acoes"></mat-divider>
    <button mat-icon-button matTooltip="Mais opções" class="accent-color btn-mais-opcoes" [matMenuTriggerFor]="menuOpcoes">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menuOpcoes="matMenu">
      <button mat-menu-item class="opcao-concluir" (click)="concluirClick()"
        [disabled]="salvando || concluida || vistoria.id === 0 || fotosVistoriaService.processando > 0"
        [matTooltip]="vistoria.id === 0 ? 'Salve a vistoria antes de concluir' : ''">
        Concluir
      </button>
      <button mat-menu-item class="opcao-baixar-laudo" (click)="baixarClick('laudo')"
        [disableNoPermission]="permissaoGerarRelatorio" [disabled]="!podeGerarRelatorio || baixarBloqueado"
        [matTooltip]="vistoria.id === 0 ? 'Salve a vistoria antes de baixar' : ''">
        Baixar laudo (PDF)
      </button>
      <button mat-menu-item class="opcao-baixar-fotos" (click)="baixarClick('fotos')"
        [disableNoPermission]="permissaoBaixarFotos" [disabled]="!podeBaixarFotos || baixarBloqueado || !temFotos"
        [matTooltip]="vistoria.id === 0 ? 'Salve a vistoria antes de baixar' : podeBaixarFotos && !temFotos ? 'A vistoria não tem fotos' : ''">
        Baixar fotos (ZIP)
      </button>
      <button *hasPermission="permissaoEditarRoteiro" mat-menu-item class="opcao-edicao-avancada" (click)="alternarEdicaoAvancada()"
        matTooltip="Libera a edição dos nomes de campos e atributos, das tags e do HTML do laudo. Vale só para esta vistoria; o modelo não é alterado.">
        {{ edicaoAvancada ? 'Desativar edição avançada' : 'Ativar edição avançada' }}
      </button>
    </mat-menu>
    <button mat-flat-button class="white-text-button" (click)="salvarClick()"
      [disabled]="salvando || concluida || fotosVistoriaService.processando > 0">
      {{ salvando ? 'Salvando...' : fotosVistoriaService.processando > 0 ? 'Processando fotos...' : 'Salvar' }}
    </button>
  </div>

  <div class="content">

    <mat-card class="main-card">

      <div class="cabecalho-vistoria">
        @if (!temModelo) {
          <p class="modelo-info">Vistoria sem modelo.</p>
        }

        <div class="campos-iniciais">
          <p-floatLabel variant="on" class="campo-endereco">
            <input pInputText id="endereco" class="input-full-width" [(ngModel)]="vistoria.endereco" />
            <label for="endereco">Endereço</label>
          </p-floatLabel>

          <p-floatLabel variant="on" class="campo-vistoriador">
            <input pInputText id="vistoriador" class="input-full-width" [(ngModel)]="vistoria.vistoriador" />
            <label for="vistoriador">Vistoriador</label>
          </p-floatLabel>

          <p-floatLabel variant="on" class="campo-data">
            <p-datepicker inputId="dataVistoria" [showIcon]="true" dateFormat="dd/mm/yy" [(ngModel)]="vistoria.data" [fluid]="true" />
            <label for="dataVistoria">Data</label>
          </p-floatLabel>
        </div>

        @if (edicaoAvancada) {
          <div class="aviso-edicao-avancada">
            <span>Edição avançada ativa: as alterações valem só para esta vistoria.</span>
            <button mat-stroked-button class="btn-desativar-edicao-avancada" (click)="alternarEdicaoAvancada()">
              Desativar
            </button>
          </div>
        }
      </div>

      <p-tabs [(value)]="abaAtiva" class="tabs-realizar-vistoria" [scrollable]="true">
        <p-tablist>
          <p-tab value="0">Campos do Relatório</p-tab>
          <p-tab value="1">Cômodos da Vistoria</p-tab>
          @if (edicaoAvancada) {
            <p-tab value="2">HTML</p-tab>
          }
          <p-tab value="3">Visualização</p-tab>
        </p-tablist>

        <p-tabpanels class="tabpanels">
          <p-tabpanel class="tabpanel" value="0">
            <app-campos-relatorio-vistoria [campos]="vistoria.campos" [mostrarTag]="edicaoAvancada"></app-campos-relatorio-vistoria>
          </p-tabpanel>
          <p-tabpanel class="tabpanel" value="1">
            <app-comodos-vistoria [comodosVistoria]="vistoria.comodos" [comodosModelo]="comodosModelo" [itensModelo]="itensModelo"
            [vistoriaId]="vistoria.id" [editarModelo]="edicaoAvancada"></app-comodos-vistoria>
          </p-tabpanel>
          @if (edicaoAvancada) {
            <p-tabpanel class="tabpanel" value="2">
              <app-html-template-editor [(html)]="vistoria.templateHtml"></app-html-template-editor>
            </p-tabpanel>
          }
          <p-tabpanel class="tabpanel" value="3">
            @if (abaAtiva === abaVisualizacao) {
              <app-visualizacao-template-html [vistoria]="vistoria" [html]="vistoria.templateHtml"></app-visualizacao-template-html>
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>

    </mat-card>

  </div>

</smrts-page>
